import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const CategorySizesPage = () => {
  const location = useLocation();
  const category = location.state; // category object passed from navigate

  const [sizes, setSizes] = useState([]);
  const [size, setSize] = useState("");
  const [description, setDescription] = useState("");

  // Fetch category sizes on load
  useEffect(() => {
    if (category?.id) {
      fetchSizes(category.id);
    }
  }, [category]);

  const fetchSizes = async (categoryId) => {
    try {
      const response = await axios.get(
        `https://goldenhides.in/api/category/size/fetch?categoryId=` + categoryId
      );
      setSizes(response.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch sizes");
    }
  };

  const handleAddSize = async (e) => {
    e.preventDefault();

    const payload = {
      size,
      description,
      categoryId: category?.id,
    };

    try {
      const response = await axios.post(
        "https://goldenhides.in/api/category/size/add",
        payload
      );
      if (response.data.success) {
        toast.success(response.data.responseMessage);
        setSize("");
        setDescription("");
        fetchSizes(category.id); // refresh list
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error while adding size");
    }
  };

  return (
    <div className="auth-background">
      <div className="container mt-4">
        <h2 className="text-center mb-3">
          Sizes for Category: {category?.title}
        </h2>
        <div className="row">
          {/* Left Section - Available Sizes */}
          <div className="col-md-6">
            <div className="card shadow-lg">
              <div className="card-header bg-color custom-bg-text">
                <h4>Available Sizes</h4>
              </div>
              <div className="card-body">
                {sizes.length > 0 ? (
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Size</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sizes.map((s) => (
                        <tr key={s.id}>
                          <td>{s.id}</td>
                          <td>{s.size}</td>
                          <td>{s.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No sizes available</p>
                )}
              </div>
            </div>
          </div>

          {/* Right Section - Add Size Form */}
          <div className="col-md-6">
            <div className="card shadow-lg">
              <div className="card-header bg-color custom-bg-text">
                <h4>Add New Size</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleAddSize}>
                  <div className="mb-3">
                    <label className="form-label">Size</label>
                    <input
                      type="text"
                      className="form-control"
                      value={size}
                      onChange={(e) => setSize(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      className="form-control"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="btn bg-color custom-bg-text">
                    Add Size
                  </button>
                  <ToastContainer />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategorySizesPage;
